// SPDX-FileCopyrightText: 2026 Magic Lane International B.V. <info@magiclane.com>
// SPDX-License-Identifier: Apache-2.0
//
// Production API token for the released examples. This file is gitignored;
// regenerate from token.template.ts if absent.

export const GEMKIT_TOKEN =
  'eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJhOWMzNDc0MS1hMTlhLTRiMzktYTFkZi01NTg3MDNlODNkNTIiLCJleHAiOjE4MzE1MDAwMDAsImlzcyI6Ik1hZ2ljIExhbmUiLCJqdGkiOiI5ODYzNDFmOC03N2MxLTRiMTQtYjcwOS0wYTdlOTM5YjVmZjYifQ.JXBlxbUwpaVLQlWnpatm0nGkEuADsjGp_DUY58_wjtKxCztR9jDDLVbIit3vitaWr-d5FIVTVyStnW7Y0ntW3w';
